import {DefaultBtn, EmptyState} from "Ncontracts.Common.UI";
import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {connect} from "react-redux";
import {Route, Switch, withRouter} from 'react-router-dom';
import {CLEAR_SELECTED_COMMUNICATION, getPastCommunications} from "../../actions/communications/communicationsAction";
import isEmpty from "../../helpers/isEmpty";
import {CommunicationListModel} from "../../Models/communications/communicationModel";
import {imageCdnUrls} from "../common/ImageCdnUrls";
import SuccessConfirmation from "../common/SuccessConfirmation";
import "./_style.scss";
import CommunicationReportsMenu from "./CommunicationReportsMenu";

class CommunicationsLandingPage extends Component {

    static propTypes = {
        getPastCommunications: PropTypes.func,
        history: PropTypes.object,
        pastCommunications: PropTypes.arrayOf(PropTypes.shape(CommunicationListModel)),
    };

    constructor(props) {
        super(props);

        this.props.getPastCommunications();
    }

    goToRoot = (returnContext) => {
        if (returnContext === undefined || returnContext.returnUrl === undefined) {
            this.props.history.push('/communications');
        } else {
            this.props.history.push(returnContext.returnUrl);
        }
    };

    showNewCommunicationPage = () => {
        this.props.history.push('/communications/new');
    };

    handleCardClick = id => {
        this.props.history.push(`/communications/${id}`);
    };

    render() {
        const sendButton = <DefaultBtn className="btn--default"
                                       onClick={this.showNewCommunicationPage}>New Communication</DefaultBtn>;

        const {pastCommunications} = this.props;

        const communicationCards = this.props.pastCommunications.map(communication => {
            return <div className="communications-list-card columns is-mobile" key={communication.id}
                        onClick={() => this.handleCardClick(communication.id)}>
                <div className="column title-cell">
                    <span className="text">{communication.title}</span>
                </div>
                <div className="column is-narrow recipient-count-cell img-with-text">
                    <img src={imageCdnUrls.users} width="25" height="25"/>
                    {communication.recipientCount}
                </div>
                <div className="column is-narrow sent-date-cell img-with-text">
                    <img src={imageCdnUrls.date_picker_blue} width="25" height="25"/>
                    <div>{communication.status === 'Sent' ? communication.sentDateString : communication.dateCreatedString}</div>
                </div>
                <div className="column is-narrow status-cell">
                    <div className={`status-pill ${communication.status.toLowerCase()}`}>{communication.status}</div>
                </div>
            </div>;
        });

        const communicationsList = isEmpty(pastCommunications) ? undefined :
            <div className="communications-list">
                {communicationCards}
            </div>;

        const noCommunicationsEmptyState = !isEmpty(pastCommunications) ? undefined :
            <EmptyState classes="no-communications-empty-state"
                        imageAlt="No communications"
                        imageSrc={imageCdnUrls.communications}
                        message="No communications"
                        button={<DefaultBtn onClick={this.showNewCommunicationPage}>New Communication</DefaultBtn>}/>;

        return (
            <div className="communications-container">
                <Switch>
                    <Route path="/communications/deleted" exact
                           render={() => <SuccessConfirmation text="Communication successfully deleted!"
                                                              closeModal={this.goToRoot}/>}/>
                    <Route path="/communications/saved" exact
                           render={() => <SuccessConfirmation text="Draft successfully saved!"
                                                              closeModal={this.goToRoot}/>}/>
                    <Route path="/communications/sent" exact
                           render={() => <SuccessConfirmation text="Message successfully sent!"
                                                              closeModal={this.goToRoot}/>}/>
                </Switch>
                <div className="landing-page">
                    <div className="page-title-row landing-page-header-container">
                        <div className="page-title">Communications</div>
                        <div className="title-right">
                            <CommunicationReportsMenu/>
                            {sendButton}
                        </div>
                    </div>
                    <div>
                        {communicationsList}
                        {noCommunicationsEmptyState}
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    pastCommunications: state.communications.pastCommunications,
});

const mapDispatchToProps = dispatch => ({
    getPastCommunications: () => {
        dispatch(getPastCommunications());
        dispatch({type: CLEAR_SELECTED_COMMUNICATION});
    }
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CommunicationsLandingPage));
